import { trackMetaCustomEvent, onMetaEventSent } from './metaPixel'
import { getLandingSource, normalizePixelId } from './landingAttribution'

export function isStandalone () {
  return !!((window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
    (window.navigator && window.navigator.standalone))
}
export function registerPwa () {
  const navigator = window.navigator
  if (window.__elevenIcPwa !== true || !navigator || !navigator.serviceWorker || !window.isSecureContext) {
    return Promise.resolve(null)
  }
  return navigator.serviceWorker.register('/11ic-sw.js', { scope: '/' }).catch(() => null)
}
const firstKey = 'pwa.11ic.firstOpen.v1'
let firstOpen
function readFirstOpen () {
  try {
    const value = JSON.parse(window.localStorage.getItem(firstKey))
    return value && typeof value.id === 'string' && value.id ? value : null
  } catch (e) { return null }
}
function persistFirstOpen () {
  // A late failed attempt must not undo another window's successful handoff.
  const saved = readFirstOpen()
  if (saved && saved.id === firstOpen.id && saved.sent === true) firstOpen.sent = true
  try {
    window.localStorage.setItem(firstKey, JSON.stringify({
      id: firstOpen.id, sent: firstOpen.sent === true,
      pixelId: firstOpen.pixelId, routeAddress: firstOpen.routeAddress
    }))
  } catch (e) {}
}
onMetaEventSent(event => {
  if (event.name !== 'PWAFirstOpen') return
  const record = firstOpen || readFirstOpen()
  if (!record || record.id !== event.id || (record.pixelId && record.pixelId !== event.pixelId)) return
  firstOpen = record
  firstOpen.pixelId = event.pixelId
  firstOpen.sent = true
  firstOpen.sending = false
  persistFirstOpen()
})

export function reportPwaFirstOpen (pixelId) {
  const target = normalizePixelId(pixelId)
  if (window.__elevenIcPwa !== true || !isStandalone() || !target) return
  if (!firstOpen) {
    firstOpen = readFirstOpen() || { id: 'pwa:first:' + Date.now() + ':' + Math.random().toString(36).slice(2), sent: false }
  }
  if (firstOpen.sent === true || firstOpen.sending) return
  if (!normalizePixelId(firstOpen.pixelId)) {
    const source = getLandingSource()
    firstOpen.pixelId = target
    firstOpen.routeAddress = source ? source.routeAddress : ''
  }
  persistFirstOpen()
  if (firstOpen.sent === true) return
  firstOpen.sending = true
  return trackMetaCustomEvent('PWAFirstOpen', firstOpen.routeAddress ? { landing_route: firstOpen.routeAddress } : {}, firstOpen.id, firstOpen.pixelId)
    .then(sent => { firstOpen.sent = firstOpen.sent === true || sent; firstOpen.sending = false; persistFirstOpen() })
}



// WEBPACK FOOTER //
// ./src/common/utils/pwaRuntime.js